import { startOfDay } from 'date-fns';
import { ContactGroup } from './contact-group';
import { SearchContactsItem } from '../../../api/api-client';

export const ContactGroups = (props: {
  contacts: SearchContactsItem[];
  totalCount: number;
  onContactSelect: (contact: SearchContactsItem) => void;
  selectedContactId: string | null;
}) => {
  const groupedContacts = props.contacts.reduce(
    (groups, contact) => {
      const date = startOfDay(new Date(contact.initiationTimestamp));
      const dateKey = date.getTime();

      if (!groups[dateKey]) {
        groups[dateKey] = {
          date,
          contacts: []
        };
      }

      groups[dateKey].contacts.push(contact);
      return groups;
    },
    {} as Record<number, { date: Date; contacts: SearchContactsItem[] }>
  );

  const sortedGroups = Object.values(groupedContacts).sort((a, b) => b.date.getTime() - a.date.getTime());

  if (sortedGroups.length === 0) {
    return <div className='p-4 text-sm text-center text-neutral-500'>No Contacts</div>;
  }

  return (
    <div className='max-h-full overflow-y-auto text-nowrap!'>
      {sortedGroups.map((group) => (
        <ContactGroup
          count={group.contacts.length}
          key={group.date.getTime()}
          date={group.date}
          contacts={group.contacts}
          onContactSelect={props.onContactSelect}
          selectedContactId={props.selectedContactId}
        />
      ))}
    </div>
  );
};
